import { createAction } from '@reduxjs/toolkit';

import { LOAD_EXTERNAL_CARRIERS, LOAD_LABELS } from './actionTypes';

export const loadLabels = createAction<{ fileId: string }>(LOAD_LABELS.BASE);
export const loadExternalCarriers = createAction(LOAD_EXTERNAL_CARRIERS.BASE);
